import React from "react";
import { Box, Skeleton } from "@mui/material";

function LoadingSpinner({ message = "Loading...", variant = "default" }) {
  if (variant === "minimal") {
    return (
      <Box 
        sx={{ 
          display: "flex", 
          flexDirection: "column", 
          alignItems: "center", 
          justifyContent: "center", 
          minHeight: "100px",
          gap: 1 
        }}
      >
        <Skeleton variant="rectangular" width={40} height={40} />
        <Skeleton variant="text" width={100} height={20} />
      </Box>
    );
  }

  return (
    <Box 
      sx={{ 
        display: "flex", 
        flexDirection: "column", 
        alignItems: "center", 
        justifyContent: "center", 
        minHeight: "200px",
        gap: 2 
      }}
    >
      <Skeleton variant="rectangular" width={60} height={60} />
      <Skeleton variant="text" width={120} height={24} />
    </Box>
  );
}

export default LoadingSpinner; 